export { default } from "./ProductDetailCustomText";
